import { Link } from "react-router-dom";
import { Globe, Truck, Shield, Users, ArrowRight } from "lucide-react";

const LOGO_URL = process.env.REACT_APP_LOGO_URL;

const values = [
  { icon: Globe, title: "Global Reach", desc: "Operating across international markets to source and deliver the best products." },
  { icon: Shield, title: "Quality Assured", desc: "Every product goes through rigorous inspection before listing." },
  { icon: Truck, title: "Reliable Logistics", desc: "End-to-end logistics support for seamless delivery worldwide." },
  { icon: Users, title: "Trusted Partners", desc: "Building long-term relationships with clients and suppliers across the globe." },
];

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="mb-16">
          <p className="text-[#DC143C] text-sm uppercase tracking-[0.2em] font-semibold mb-3">
            About Us
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white mb-6">
            Imperial Exim<br />
            <span className="text-[#DC143C]">Trading LLC</span>
          </h1>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-24">
          <div>
            <div className="aspect-square rounded-lg overflow-hidden border border-white/10 bg-[#0A0A12] flex items-center justify-center p-12">
              <img src={LOGO_URL} alt="Imperial Exim Trading LLC" className="w-full max-w-xs" />
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-white mb-6">
              Your Global Trading Partner
            </h2>
            <div className="space-y-4 text-[#9CA3AF] text-base leading-relaxed">
              <p>
                Imperial Exim Trading LLC is a dynamic international trading company specializing in the
                supply and trading of transportation equipment, metals, and general cargo.
              </p>
              <p>
                We deal in new and used 20ft and 40ft skeleton and flatbed trailers designed for container
                transport, serving logistics companies and fleet operators across the globe.
              </p>
              <p>
                Our metals trading division handles both ferrous and non-ferrous metals, connecting
                producers with end-users and manufacturers worldwide. Additionally, we facilitate
                general cargo trading for businesses seeking reliable sourcing partners.
              </p>
              <p>
                With a commitment to quality, transparency, and client satisfaction, we have built a
                reputation as a trusted name in international trading.
              </p>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="mb-24">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-white mb-10 text-center">
            Why Choose Us
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="values-grid">
            {values.map((v, i) => {
              const Icon = v.icon;
              return (
                <div
                  key={i}
                  data-testid={`value-card-${i}`}
                  className="p-6 bg-[#0A0A12] border border-white/10 rounded-lg hover:border-[#DC143C]/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(220,20,60,0.1)]"
                >
                  <div className="w-12 h-12 rounded-md bg-[#DC143C]/10 border border-[#DC143C]/30 flex items-center justify-center mb-4">
                    <Icon size={22} className="text-[#DC143C]" />
                  </div>
                  <h3 className="text-white font-semibold text-base mb-2">{v.title}</h3>
                  <p className="text-[#9CA3AF] text-sm leading-relaxed">{v.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center p-12 bg-[#0A0A12] border border-white/10 rounded-lg">
          <h2 className="text-2xl font-bold text-white mb-4">Ready to Work With Us?</h2>
          <p className="text-[#9CA3AF] text-base mb-8 max-w-md mx-auto">
            Whether you're looking for trailers, metals, or cargo, we're here to help.
          </p>
          <Link
            to="/contact"
            data-testid="about-contact-cta"
            className="inline-flex items-center gap-2 bg-[#DC143C] text-white font-semibold tracking-wide px-7 py-3.5 rounded-md hover:bg-[#B01030] transition-colors"
          >
            Get In Touch <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
}
